import { motion } from 'framer-motion';

const Vacancies = () => {
  return (
    <div className="min-h-screen pt-24 bg-dark-gray">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-r from-dark-gray to-gray-900">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Join Our <span className="text-burnt-orange">Team</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Exciting opportunities to be part of our creative journey
            </p>
          </motion.div>
        </div>
      </section>

      {/* Vacancies Section */}
      <section className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          {/* Executive Assistant Position */}
          <motion.div 
            className="bg-gray-900/50 rounded-xl p-8 mb-16"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-3xl font-bold text-white mb-2">EXECUTIVE ASSISTANT</h2>
            <div className="w-20 h-1 bg-burnt-orange mb-8"></div>
            
            <h3 className="text-2xl font-semibold text-white mb-4">We're Hiring an Executive Assistant</h3>
            <p className="text-gray-300 mb-8">
              SAMFREN OJO MEDIA is expanding, and we're looking for a smart, organized, and reliable Executive Assistant to work closely with the Founder.
            </p>
            
            <div className="h-px bg-gray-700 my-8"></div>
            
            <h4 className="text-xl font-semibold text-white mb-4">ROLE OVERVIEW</h4>
            <p className="text-gray-300 mb-8">
              As an Executive Assistant, you will help manage day-to-day operations, schedules, communication, and administrative tasks across multiple projects.
            </p>
            
            <div className="h-px bg-gray-700 my-8"></div>
            
            <h4 className="text-xl font-semibold text-white mb-4">KEY RESPONSIBILITIES</h4>
            <ul className="list-disc pl-6 text-gray-300 mb-8 space-y-2">
              <li>Manage schedules, meetings, and reminders</li>
              <li>Handle emails, follow-ups, and basic documentation</li>
              <li>Assist with project coordination and deadlines</li>
              <li>Organize files, tasks, and workflows</li>
              <li>Support daily operations of the media company and academy</li>
            </ul>
            
            <div className="h-px bg-gray-700 my-8"></div>
            
            <h4 className="text-xl font-semibold text-white mb-4">REQUIREMENTS</h4>
            <ul className="list-disc pl-6 text-gray-300 mb-8 space-y-2">
              <li>Strong organizational and communication skills</li>
              <li>Ability to multitask and work independently</li>
              <li>Familiar with Google Docs, Drive, and Calendar</li>
              <li>Detail-oriented and reliable</li>
              <li>Previous admin or assistant experience is a plus</li>
            </ul>
            
            <div className="h-px bg-gray-700 my-8"></div>
            
            <h4 className="text-xl font-semibold text-white mb-4">WHO THIS ROLE IS FOR</h4>
            <ul className="list-disc pl-6 text-gray-300 mb-8 space-y-2">
              <li>Someone proactive and disciplined</li>
              <li>Someone who can think ahead and follow through</li>
              <li>Someone interested in working closely with a creative entrepreneur</li>
            </ul>
            
            <div className="h-px bg-gray-700 my-8"></div>
            
            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div>
                <h4 className="text-xl font-semibold text-white mb-2">LOCATION / MODE</h4>
                <p className="text-gray-300">Hybrid (Abuja-based preferred)</p>
              </div>
              <div>
                <h4 className="text-xl font-semibold text-white mb-2">HOW TO APPLY</h4>
                <p className="text-gray-300">
                  Send your resume and letter to{' '}
                  <a href="mailto:info@samfrenojomedia.com" className="text-burnt-orange hover:underline">
                    info@samfrenojomedia.com
                  </a>{' '}
                  or{' '}
                  <a href="mailto:samfrenojomedia@gmail.com" className="text-burnt-orange hover:underline">
                    samfrenojomedia@gmail.com
                  </a>
                </p>
                <p className="text-gray-400 text-sm mt-2">Application deadline: 25th January 2026</p>
              </div>
            </div>
          </motion.div>

          {/* Interns Position */}
          <motion.div 
            className="bg-gray-900/50 rounded-xl p-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h2 className="text-3xl font-bold text-white mb-2">INTERNS (MEDIA & ADMIN)</h2>
            <div className="w-20 h-1 bg-burnt-orange mb-8"></div>
            
            <h3 className="text-2xl font-semibold text-white mb-4">We're Hiring Interns</h3>
            <p className="text-gray-300 mb-8">
              SAMFREN OJO MEDIA is offering internship opportunities for young, passionate individuals who want real-world experience in media, storytelling, and creative operations.
            </p>
            
            <div className="h-px bg-gray-700 my-8"></div>
            
            <h4 className="text-xl font-semibold text-white mb-4">AVAILABLE INTERNSHIP ROLES</h4>
            <ul className="list-disc pl-6 text-gray-300 mb-8 space-y-2">
              <li>Media / Production Intern</li>
              <li>Admin / Research Intern</li>
            </ul>
            
            <div className="h-px bg-gray-700 my-8"></div>
            
            <h4 className="text-xl font-semibold text-white mb-4">INTERN ROLE OVERVIEW</h4>
            
            <div className="mb-6">
              <h5 className="text-lg font-semibold text-burnt-orange mb-2">Media / Production Intern</h5>
              <ul className="list-disc pl-6 text-gray-300 space-y-1">
                <li>Assist on shoots and content production</li>
                <li>Help with behind-the-scenes content</li>
                <li>Support basic editing and file organization</li>
              </ul>
            </div>
            
            <div className="mb-8">
              <h5 className="text-lg font-semibold text-burnt-orange mb-2">Admin / Research Intern</h5>
              <ul className="list-disc pl-6 text-gray-300 space-y-1">
                <li>Assist with research and documentation</li>
                <li>Support media academy and creator platform projects</li>
                <li>Help organize data, ideas, and community activities</li>
              </ul>
            </div>
            
            <div className="h-px bg-gray-700 my-8"></div>
            
            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div>
                <h4 className="text-xl font-semibold text-white mb-4">REQUIREMENTS</h4>
                <ul className="list-disc pl-6 text-gray-300 space-y-2">
                  <li>Willingness to learn and grow</li>
                  <li>Good communication skills</li>
                  <li>Reliable and committed</li>
                  <li>Basic knowledge of media or digital tools is a plus</li>
                </ul>
              </div>
              
              <div>
                <h4 className="text-xl font-semibold text-white mb-4">WHO SHOULD APPLY</h4>
                <ul className="list-disc pl-6 text-gray-300 space-y-2">
                  <li>Students or recent graduates</li>
                  <li>Beginner creatives or media enthusiasts</li>
                  <li>Anyone looking to gain hands-on industry experience</li>
                </ul>
              </div>
            </div>
            
            <div className="h-px bg-gray-700 my-8"></div>
            
            <h4 className="text-xl font-semibold text-white mb-4">WHAT YOU'LL GAIN</h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
              {['Practical experience', 'Mentorship', 'Industry exposure', 'Opportunity for long-term collaboration'].map((item, index) => (
                <div key={index} className="bg-gray-800/50 p-4 rounded-lg text-center">
                  <p className="text-burnt-orange font-medium">{item}</p>
                </div>
              ))}
            </div>
            
            <div className="h-px bg-gray-700 my-8"></div>
            
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h4 className="text-xl font-semibold text-white mb-2">LOCATION / MODE</h4>
                <p className="text-gray-300">Hybrid / Remote (Abuja-based)</p>
              </div>
              <div>
                <h4 className="text-xl font-semibold text-white mb-2">HOW TO APPLY</h4>
                <p className="text-gray-300">
                  Send your resume and letter to{' '}
                  <a href="mailto:info@samfrenojomedia.com" className="text-burnt-orange hover:underline">
                    info@samfrenojomedia.com
                  </a>{' '}
                  or{' '}
                  <a href="mailto:samfrenojomedia@gmail.com" className="text-burnt-orange hover:underline">
                    samfrenojomedia@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Vacancies;
